<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">money_off</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Excluir financeiro</h2>
        <span class="modal-subtitle">{{ data.rotuloDocumento }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content scroll-suave">
    @if (isLoading) {
        <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
    } @else {
        @if (!temFinanceiro) {
            <app-alert-card type="info" title="Nada a excluir">
                O Finanças não tem financeiro ativo desta nota. Confirmar só atualiza o registro da nota.
            </app-alert-card>
        } @else {
            <p class="descricao-modal">
                Tudo ou nada: parcela já recebida, agrupada, movimentação conciliada ou data em período fechado
                impede a exclusão inteira; resolva no Finanças e tente de novo. Parcela com boleto ou Pix é
                cancelada junto com a cobrança; sem cobrança, é excluída.
            </p>

            @if (bloqueios.length) {
                <app-alert-card type="warning" title="A exclusão está bloqueada">
                    <ul class="nfeef-bloqueios">
                        @for (motivo of bloqueios; track $index) { <li>{{ motivo }}</li> }
                    </ul>
                </app-alert-card>
            }

            <app-nfe-financeiro-lancamentos [contas]="contas" [movimentacoes]="movimentacoes" [isExclusao]="true"></app-nfe-financeiro-lancamentos>
        }

        <mat-form-field appearance="outline" class="w-100 nfeef-justificativa">
            <mat-label>Justificativa</mat-label>
            <textarea matInput rows="3" maxlength="500" [formControl]="justificativa"
                placeholder="Informe o motivo da exclusão"></textarea>
            <mat-hint align="end">{{ justificativa.value.length }}/500</mat-hint>
            @if (justificativa.hasError('required') || justificativa.hasError('minlength')) {
                <mat-error>Informe a justificativa com ao menos 10 caracteres.</mat-error>
            }
        </mat-form-field>
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isExcluindo" (click)="fechar()">Cancelar</button>
    <span [matTooltip]="tooltipExcluir" [matTooltipDisabled]="!tooltipExcluir">
        <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isExcluindo"
            [disabled]="!podeExcluir || isExcluindo" [attr.aria-label]="isExcluindo ? 'Excluindo financeiro' : 'Excluir financeiro'"
            (click)="confirmar()">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            Excluir financeiro
            @if (isExcluindo) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
    </span>
</mat-dialog-actions>
